// @flow
import * as React from 'react'
import {
  colors
} from '@components/shared'
import styled from 'styled-components'
import Modal from '@components/shared/FullScreenModal'
import { H1 } from '@components/shared/typography'
import { config } from 'react-awesome-styled-grid'
import Badges from '@components/Badges'

type PropsType = {
  isVisible: boolean,
  handleClose: () => void,
  title: string,
  description: string
}
export default function ChapterDownloadModal (props: PropsType): React.Node {
  return (
    <Modal
      isVisible={props.isVisible}
      disableFullScreenMobile
      overflow='unset'
      toggleModalFunction={props.handleClose }
      closeButtonHeight={60}
      bgGradient={false}
    >
      <Card>
        <TextContainer>
          <LogoImg src="/images/dipsea-logo.png" />
          <Header>{props.title}</Header>
          <DescriptionContainer>{props.description}</DescriptionContainer>
          <CtaContainer>
            Read the rest of this sexy story over on our app.
            <BadgesContainer>
              <Badges badgesOnly webApp={false}/>
            </BadgesContainer>
          </CtaContainer>

        </TextContainer>
      </Card>
    </Modal>
  )
}

const BadgesContainer = styled.div`
    margin-top: 18px;
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
      margin-top: 24px;
  `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`
const CtaContainer = styled.div`
    font-family: "Good Sans Regular";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    color: ${colors.white};
    padding-top: 30px;
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
  `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`
const DescriptionContainer = styled.div`
    font-family: "Good Sans Regular";
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px; /* 150% */
    letter-spacing: -0.3px;
    color: ${colors.white};
    border-bottom: 0.5px solid ${colors.white70};
    padding-bottom: 42px;
    &::first-letter {
        initial-letter: 2;
        margin-right: 8px;
        font-weight: 500;
    }
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
  `}
    ${(props: any): string => config(props).media.lg`
    font-size: 18px;
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`
const LogoImg = styled.img`
  display: block;
  width: 52px;
  ${(props: any): string => config(props).media.md`
      width: 63px;
  `}
  
`

const Header = styled(H1)`
  color: ${colors.white};
  font-family: "Queens Condensed Light";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 110%;
  margin-top: 25px;
  margin-bottom: 22px;
  text-align: center;
  ${(props: any): string => config(props).media.md`
    font-size: 36px;
    margin-top: 32px;
    margin-bottom: 32px;
  `}

  ${(props: any): string => config(props).media.lg`
    font-size: 45px;
  `}
`

const Card = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
  position: relative;
  ${(props: any): string => config(props).media.sm`
    max-width: 400px;
  `}
  ${(props: any): string => config(props).media.lg`
    max-width: 472px;
  `}
`
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`
